// extracted by mini-css-extract-plugin
module.exports = {"PostList__container":"PostList_PostList__container___WvLI","PostList__loading":"PostList_PostList__loading__ZczAZ","fadeInKeyframe":"PostList_fadeInKeyframe__8nte4"};